import React from 'react';
import { Column, Container, Row } from '@src/elements/Grid';
import { CtaFragment, GlobalSettingItemFragment } from '@src/graphql/gql-types';
import { COLOR_WHITE } from '@src/types/colors';
import styles from './GlobalCTAPanel.module.scss';
import RichTextRender from '@src/components/RichTextRender';
import { CONTENTFUL_PAGE_CONTENT_TYPES } from '@src/constants/contentful';
import { RICHTEXT_RENDER_MODE } from '@src/types/richText';
import { getArrayOfCTAs } from '@src/utils/helpers';
import EnquireButton from '../Header/EnquireButton';
import { ButtonLinkStandard } from '../ButtonLink';
import BoxIcon from '@src/elements/BoxIcon';
import { FOOTER_SCROLL_TO_ID } from '@src/constants/site';

type GlobalCTAPanel = GlobalSettingItemFragment;

const GlobalCTAPanel: React.FC<GlobalCTAPanel> = ({
  richText,
  callToActionCollection
}) => {
  const ctasArray = getArrayOfCTAs(
    callToActionCollection?.items as CtaFragment[]
  );

  const renderCTAButton = (cta: CtaFragment, index: number) => {
    return cta.urlLink === '#footerEnquireForm' ? (
      <EnquireButton
        key={`${cta.label}-${index}`}
        scrollToId={FOOTER_SCROLL_TO_ID}
        testid="globalCtaPanelEnquireButton"
        size="md"
        iconPosition="left"
      />
    ) : (
      <ButtonLinkStandard
        key={`${cta.label}-${index}`}
        data-testid="headerPhoneNumberButton"
        color={COLOR_WHITE}
        aria-label="Phone"
        size="md"
        href={`tel:${cta.label}`}
        className={styles.phoneButton}
      >
        {/* TODO: move to ButtonLinkStandard "icon" prop once that's switched to BoxIcon */}
        <BoxIcon name="phone" size="sm" />
        {cta.label}
      </ButtonLinkStandard>
    );
  };

  return (
    <div className={styles.panelContainer}>
      <Container>
        <Row>
          <Column align="center" justify="center">
            {richText && (
              <RichTextRender
                bodyContent={richText}
                pageType={CONTENTFUL_PAGE_CONTENT_TYPES.NATIONAL_STANDARD} // Forcing this type at the moment, but it might not be needed/or applied in this instance
                renderMode={RICHTEXT_RENDER_MODE.NO_BLOCK_EMBEDS}
              />
            )}

            <div className={styles.ctasContainer}>
              {ctasArray?.map(renderCTAButton)}
            </div>
          </Column>
        </Row>
      </Container>
    </div>
  );
};

export default GlobalCTAPanel;
